<script setup>
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  }
});
const availableCountries = [
  {
    name: "France",
    code: "FR",
    cities: [
      "Paris",
      "Marseille",
      "Toulouse",
      "Nice",
      "Lyon",
      "Bordeaux",
      "Strasbourg",
      "Montpellier",
      "Reims",
      "Toulon"
    ]
  },
  {
    name: "Germany",
    code: "DE",
    cities: ["Berlin", "Hamburg", "Stuttgart", "Munich", "Cologne"]
  },
  {
    name: "Belgium",
    code: "BE",
    cities: ["Antwerp", "Bruges", "Brussels", "Liege", "Ostende"]
  },
  {
    name: "Switzerland",
    code: "CH",
    cities: ["Zurich", "Basel", "Lausanne", "Geneva", "Bern"]
  },
  {
    name: "UK",
    code: "GB",
    cities: ["London", "Birmingham", "Manchester", "Glasgow", "Edinburgh"]
  },
  {
    name: "Netherland",
    code: "NL",
    cities: ["Amsterdam", "Rotterdam", "Utrecht", "Eindhoven", "Maastricht"]
  },
  {
    name: "Italy",
    code: "IT",
    cities: ["Rome", "Milan", "Turin", "Florence", "Genes"]
  },
  {
    name: "Spain",
    code: "ES",
    cities: ["Madrid", "Barcelona", "Malaga", "Valencia", "Seville"]
  },
  {
    name: "Portugal",
    code: "PT",
    cities: ["Lisbon", "Porto", "Braga", "Coimbra", "Faro"]
  }
];
</script>

<template>
    <div class="city-list">
        <ul class="md:row-[1/_span_2] md:self-center w-fit">
            <li class="country">{{ $t("country.france") }}</li>
            <div class="city-container">
                <div
                    v-for="(city, index) of availableCountries[0]?.cities || []"
                    :key="city"
                    :class="[index > 2 && 'hidden md:block']"
                >
                    <NuxtLink
                        class="city-name"
                        :to="`/${language}-${country}/cities/${city.toLowerCase()}-${availableCountries[0]?.code}`"
                        external
                        :title="city"
                    >
                        {{ city }}
                    </NuxtLink>
                </div>
            </div>
        </ul>

        <ul
            v-for="availableCountry of availableCountries.slice(1)"
            :key="availableCountry.name"
            class="w-fit"
        >
            <li class="country">
                {{ $t(`country.${availableCountry.name.toLowerCase()}`) }}
            </li>
            <div class="city-container">
                <div
                    v-for="(city, index) of availableCountry.cities"
                    :key="city"
                    :class="[index > 2 && 'hidden md:block']"
                >
                    <NuxtLink
                        class="city-name"
                        :to="`/${language}-${country}/cities/${city.toLowerCase()}-${availableCountry.code}`"
                        external
                        :title="city"
                    >
                        {{ city }}
                    </NuxtLink>
                </div>
            </div>
        </ul>
    </div>
</template>

<style scoped>
.city-list {
  @apply px-4 pb-4 md:py-9 md:px-14 grid grid-rows-5 md:grid-rows-2 grid-flow-col gap-y-2.5 gap-x-4 text-gray-l-700 md:justify-between mx-auto max-w-[1280px];
}
.city-list > li,
.city-list a {
  line-height: 120%;
}
.city-list .city-name {
  @apply flex text-zinc-700 hover:text-sky-400 active:text-sky-700 active:font-semibold whitespace-nowrap text-ellipsis text-[13px] xl:text-[15px];
}
.city-list .country {
  @apply font-bold text-[15px] py-2 pr-4 text-sky-700;
}
.city-list .city-container {
  @apply flex flex-col gap-2 md:block;
}
</style>
